export const DELETE_ACCOUNT = 'USER/DELETE_ACCOUNT';
export const DELETE_ACCOUNT_PENDING = `${DELETE_ACCOUNT}_PENDING`;
export const DELETE_ACCOUNT_FULFILLED = `${DELETE_ACCOUNT}_FULFILLED`;
export const DELETE_ACCOUNT_REJECTED = `${DELETE_ACCOUNT}_REJECTED`;

export const deleteAccount = () => ({
  type: DELETE_ACCOUNT,
});

export const RELOAD = 'USER/DELETE_ACCOUNT/RELOAD';
export const CANCEL_RELOAD = 'USER/DELETE_ACCOUNT/CANCEL_RELOAD';

export const cancelReload = () => ({
  type: CANCEL_RELOAD,
});
